import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, SelectionControl } from "react-md";
import validator from "components/Shared/MGridFormDefinitions/validator";
import MGridForm from "components/Shared/MGridForm";
import { DATA_TYPE_MULTI_LINE_STRING, DATA_TYPE_CHECKBOX } from "typeConstants/dataTypes";
import { MSpinner } from "components/Shared";
import { sendMessage } from "requests/dwellingBlocks/index";

interface MessageFormProps  {
  controlNumber: number;
  canSendMessage: boolean;
  onSuccessCallback?: () => void;
}

const Message: React.FC<MessageFormProps> = ({ controlNumber, onSuccessCallback, canSendMessage }) => {
  const [messageRequest, setMessageRequest] = useState({
    message: "",
    requiresAttention: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const controlMethods = useRef<{
    isFormValid?: () => boolean;
    getModifiedData?: () => Array<{ id: string; value: any }>;
    setFieldModified?: (id: string, val: any) => void;
  }>({});
  const mounted = useRef(true);

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  if (isSubmitting) {
    return <MSpinner />;
  }

  const formDefinition = [
    [{ dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Message:", source: "message", hasValidationError: validator.required }],
  ];

  const isValid = () => controlMethods.current?.isFormValid?.() ?? false;
  const handleOnChange = (updatedObject: typeof messageRequest) => setMessageRequest({ ...updatedObject });

  const handleSend = () => {
    if (isValid()) {
      setIsSubmitting(true);
      sendMessage(controlNumber, messageRequest.requiresAttention, messageRequest.message, onSuccess, onError, mounted);
    }
  };

  const onSuccess = () => {
    if (onSuccessCallback) onSuccessCallback();
  };

  const onError = () => {
    setIsSubmitting(false);
  };

  return (
    <div>
      <MGridForm
        key="dwelling-blocks-message-form"
        data={messageRequest}
        onChange={handleOnChange}
        formDefinition={formDefinition}
        getControlMethods={cm => { controlMethods.current = cm; }}
        webform={true}
      />

      <div style={{display: "flex", alignItems: "center", gap: "1rem", marginTop: "1rem"}}>
        <Button
          primary
          raised
          key="message-send-button"
          onClick={handleSend}
          disabled={!isValid() || !canSendMessage}
        >
        Send
        </Button>
        <SelectionControl
          id="attention-required-checkbox"
          label="Attention Required"
          type="checkbox"
          name="requiresAttention"
          checked={messageRequest.requiresAttention}
          onChange={(checked) =>
          setMessageRequest(prev => ({
              ...prev,
              requiresAttention: Boolean(checked)
            }))
          }
          disabled={!canSendMessage}
        />
      </div>
    </div>
  );
};

Message.propTypes = {
  controlNumber: PropTypes.number.isRequired,
  canSendMessage: PropTypes.bool.isRequired,
  onSuccessCallback: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    controlNumber: state.caseDetails.controlNumber,
  };
};

export default connect(mapStateToProps)(Message);